import {
  motion,
  useAnimation,
  useSpring,
  useTime,
  useTransform,
  Variants,
} from "framer-motion";
import { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useBoolean, useMount, useTimeoutFn, useWindowSize } from "react-use";
import styled, { css } from "styled-components";
import { Video } from "../../mock/video-wall";
import { fill } from "../../styles/utils";
import { Box } from "../Box";
import ButtonText from "../buttons/ButtonText";
import { FlexItem } from "../Flex";
import Icon from "../Icon";
// import ShareButton from "../ShareButton";
import { Text } from "../Text";

interface VideoWallPlayerProps {
  video: Video;
  domRect: any;
  startAt: number;
  onCloseClick?: () => any;
  onReady?: () => any;
  onPlay?: () => any;
  show?: boolean;
}

const START_TIME = 1200 + 2000;
const END_TIME = 1800 + 2000;
const END_TIME2 = 2400;

const Wrapper = styled.div`
  ${fill()}
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
`;

const VideoWrapper = styled(motion.div)<{ width: number; height: number }>`
  ${({ width, height }) => css`
    // width: ${width}px;
    // height: ${height}px;
    // padding-top: ${(height / width) * 100}%;
  `}
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: center;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  overflow: hidden;
`;

const VideoWrapperInner = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  aspect-ratio: 16/9;
  transform: translate(-50%, -50%);
`;

const StyledReactPlayer = styled(ReactPlayer)`
  pointer-events: none;
`;

const Backdrop = styled.div`
  ${fill()};
  z-index: -1;
`;

const MetaHolder = styled(motion.div)`
  /* transform: translate(-50%, -50%); */
  padding: 10px 0;
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  top: 100%;
  align-items: center;
`;

const variants: Variants = {
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { duration: 1 } },
};

const otherVariants: Variants = {
  initial: { opacity: 0, y: -20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2, delay: 2 } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.2 } },
};

export const VideoWallPlayer: React.FC<VideoWallPlayerProps> = ({
  video,
  domRect,
  startAt,
  onCloseClick,
  onReady,
  onPlay,
  show,
}) => {
  const [duration, setDuration] = useState("0");
  const [showControls, setShowControls] = useBoolean(false);
  const [playing, setPlaying] = useBoolean(false);

  const player = useRef<ReactPlayer>(null);

  const { width, height } = useWindowSize();

  const videoAnimation = useAnimation();

  const handleOnReady = async () => {
    if (player.current) {
      player.current.seekTo(startAt);
      onReady && onReady();

      setPlaying(true);
    }
  };

  const handleOnPlay = async () => {
    console.log("canplay");
    onPlay && onPlay();
    if (player.current) {
      const durationInSeconds = player.current.getDuration();
      const mins = Math.floor(durationInSeconds / 60);
      const secs = durationInSeconds - mins * 60;
      console.log(mins, secs);
      setDuration(`${mins}:${secs}`);
    }

    videoAnimation.set({
      x: domRect.x - (width / 2 - (width * 0.65) / 2),
      y: domRect.y - (height / 2 - (width * 0.567 * 0.65) / 2),
      width: domRect.width,
      height: domRect.height,
    });
    await videoAnimation.start({
      x: 0,
      y: 0,
      width: width * 0.65,
      height: width * 0.567 * 0.65,
      transition: { duration: 1 },
    });
  };

  useTimeoutFn(() => {
    setShowControls(true);
  }, 2000);

  const handleCLoseClick = async () => {
    await videoAnimation.start({
      opacity: 0,
      transition: { duration: 1 },
    });
    onCloseClick && onCloseClick();
  };

  return (
    <Wrapper>
      <Backdrop onClick={handleCLoseClick} />
      <Box width="65%">
        <Box paddingTop="56.7%" position="relative" opacity={show ? 1 : 0}>
          {/* <VideoWrapper
            id="player"
            width={domRect.width}
            height={domRect.height}
            initial={false}
            animate="animate"
            exit="exit"
            variants={variants}
            style={{
              x: xMovement,
              y: yMovement,
              width: videoWidth,
              height: videoHeight,
            }}
          > */}
          <VideoWrapper
            id="player"
            width={domRect.width}
            height={domRect.height}
            animate={videoAnimation}
          >
            <VideoWrapperInner
              width={video.height > video.width ? "auto" : "110%"}
              height={video.height > video.width ? "110%" : "auto"}
            >
              <StyledReactPlayer
                onReady={handleOnReady}
                onStart={handleOnPlay}
                controls={false}
                loop={true}
                ref={player}
                url={video.src}
                width="100%"
                height="100%"
                playing={playing}
              ></StyledReactPlayer>
            </VideoWrapperInner>
            {/* <video
              autoPlay
              muted
              loop
              onLoadedMetadata={handleOnLoad}
              onCanPlay={handleOnCanPlay}
              controls={showControls}
              ref={videoRef}
            >
              <source src={video.src}></source>
            </video> */}
          </VideoWrapper>

          <MetaHolder
            initial="initial"
            animate="animate"
            exit="exit"
            variants={otherVariants}
          >
            <FlexItem px={2}>
              <Text fontWeight={700}>{video.name}</Text>
            </FlexItem>
            <FlexItem px={2}>
              <Text as="span" verticalAlign="middle">
                {duration}
              </Text>

              <Box as="span" verticalAlign="middle">
                <Icon icon="play" />
              </Box>
            </FlexItem>
            <FlexItem px={2}>
              <ButtonText icon="reply" iconSize="sm">
                Share
              </ButtonText>
            </FlexItem>
          </MetaHolder>
        </Box>
      </Box>
    </Wrapper>
  );
};

// const xMovement = useTransform(
//   springTime,
//   [START_TIME, END_TIME],
//   [domRect.x - (width / 2 - (width * 0.65) / 2), 0]
// );
// const yMovement = useTransform(
//   springTime,
//   [START_TIME, END_TIME],
//   [domRect.y - (height / 2 - (width * 0.567 * 0.65) / 2), 0]
// );
// const videoWidth = useTransform(
//   springTime,
//   [START_TIME, END_TIME],
//   [domRect.width, width * 0.65]
// );
// const videoHeight = useTransform(
//   springTime,
//   [START_TIME, END_TIME],
//   [domRect.height, width * 0.567 * 0.65]
// );
// const springTime = useSpring(time, physics);

// const time = useTime();
// const physics = { damping: 5, mass: 0.5, stiffness: 20 };
